import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import type { FormInputs } from "./form-validation/user-reset-password.schema";
import { schema, defaultValues } from "./form-validation/user-reset-password.schema";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import { ArrowBigLeft } from "lucide-react";
import { ThemedButton } from "@shared-kernel/primary/shared/themed-button/themed-button";

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (formBody: any) => void;
  onBack: () => void;
}

const ResetForm = ({ onSubmit, onBack }: Props) => {
  const methods = useForm<FormInputs>({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const {
    formState: { isDirty },
  } = methods;

  return (
    <Form {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="w-full">
        <div className="space-y-2">
          <FormField
            control={methods.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email</FormLabel>
                <FormControl>
                  <Input {...field} type="email" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="flex items-center justify-between gap-x-2">
            <div onClick={onBack} role="button" className="flex items-center justify-between hover:font-semibold">
              <ArrowBigLeft />
              <span>Retour</span>
            </div>
            <ThemedButton isDirty={isDirty} label="Soumettre" />
          </div>
        </div>
      </form>
    </Form>
  );
};

export default ResetForm;
